import currency from 'currency.js'
export const xcdToUsd = xcdValue => currency(xcdValue).multiply(1/2.67).value
export const xcdToPaypalUsd = xcdValue => currency(xcdValue).multiply(0.36082).value